// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"544":"5090b36a7d8e10be7c23","748":"ab792ddd0284fb54e2d7","799":"0089e83ab16dc0ac3b0a","963":"6b562483dace22a1c737"}[chunkId] + ".chunk.js";
};